import * as moment from 'moment'
import { mapGetters } from 'vuex'

export default {
  props: {
    shipmentList: Array,
    selectedtabs: String
  },
  computed: {
    ...mapGetters({
      // get shipment per page
      shipment: 'shipment/items',
      isLoading: 'shipment/isLoading',
      isError: 'shipment/error',

      getFilterShipment: 'shipment/getFilterShipment',
      errorGetFilterShipment: 'shipment/errorGetFilterShipment',
      isLoadingGetFilterShipment: 'shipment/isLoadingGetFilterShipment'
    })
  },
  methods: {
    getImageShipment (type) {
      if (type === 'OCEAN') {
        return require('@/assets/image/icon/shipment-ocean.svg')
      } else if (type === 'LAND') {
        return require('@/assets/image/icon/shipment-land.svg')
      }
      return require('@/assets/image/icon/shipment-air.svg')
    },
    getProgress (item, type) {
      let percentage = ''
      if (type === 'bottom') {
        percentage = `height: ${item}%`
      } else {
        const newPercentage = 100 - parseFloat(item)
        percentage = `height: ${newPercentage}%`
      }
      return percentage
    },
    getImageCanceledRejected (type) {
      let imageSource = ''
      if (type === 'REJECTED') {
        imageSource = require('@/assets/image/icon/rejected.svg')
      }
      if (type === 'CANCELLED') {
        imageSource = require('@/assets/image/icon/canceled.svg')
      }
      return imageSource
    },
    getImageOtif (otif, type) {
      let image = ''
      switch (otif) {
        case 'BOOKED':
          image = type === 'LAND' ? require('@/assets/image/icon/ms-booked-land.svg') : require('@/assets/image/icon/ms-booked.svg')
          break
        case 'SCHEDULED_OTIF':
          image = type === 'OCEAN' ? require('@/assets/image/icon/ms-scheduled-ocean.svg') : type === 'LAND' ? require('@/assets/image/icon/ms-scheduled-land.svg') : require('@/assets/image/icon/ms-schedule.svg')
          break
        case 'PICKUP':
          image = type === 'OCEAN' ? require('@/assets/image/icon/ms-pickup.svg') : require('@/assets/image/icon/ms-pickup-purple.svg')
          break
        case 'ORIGIN_LOCAL_HANDLING':
        case 'DESTINATION_LOCAL_HANDLING':
          image = type === 'OCEAN' ? require('@/assets/image/icon/ms-handling.svg') : require('@/assets/image/icon/ms-handling-purple.svg')
          break
        case 'ARRIVAL':
        case 'DEPARTURE':
          image = type === 'OCEAN' ? require('@/assets/image/icon/ms-ship.svg') : require('@/assets/image/icon/ms-airplane-purple.svg')
          break
        case 'DELIVERY':
          image = type === 'OCEAN' ? require('@/assets/image/icon/ms-deliv.svg') : require('@/assets/image/icon/ms-deliv-purple.svg')
          break
        case 'COMPLETED_OTIF':
          image = require('@/assets/image/icon/ms-completed-green.svg')
          break
        case 'REJECTED':
        case 'CANCELLED':
          image = require('@/assets/image/icon/ms-scheduled-air-purple.svg')
          break
        case 'STARTED':
          image = require('@/assets/image/icon/ms-started-blue.svg')
          break
        case 'UNLOADING':
        case 'LOADING':
          image = require('@/assets/image/icon/ms-loading-blue.svg')
          break
        case 'INTRANSIT':
          image = require('@/assets/image/icon/ms-intransit-blue.svg')
          break
        case 'DELIVERED':
          image = require('@/assets/image/icon/ms-delivered-blue.svg')
          break
        default: image = ''
      }
      return image
    },
    getFilterStatus (item) {
      const item2 = item.replace(/_/g, ' ')
      const item3 = item2 === 'PICKUP' ? 'PICK UP' : item2.replace(/ OTIF/g, '')
      return item3.toLowerCase()
    },
    getListShipment () {
      const today = moment().format('YYYY-MM-DD')
      if (this.manageType === 'Ongoing') {
        return this.shipmentList
      }
      return this.shipmentList.filter((item) => {
        const showExpiredList = moment(item.updatedAt).add(3, 'days').format('YYYY-MM-DD')
        return (((item.orderStat === 'COMPLETED_OTIF') && (today > showExpiredList)) || (item.orderStat === 'REJECTED') || (item.orderStat === 'CANCELLED'))
      })
    },
    getFilterShipmentType (type) {
      if (type === 'AIRCARGO' || type === 'aircargo') {
        const newType = type.replace(type, 'Air Cargo')
        return newType
      } if (type === 'AIRCOURIER' || type === 'aircourier') {
        const newType = type.replace(type, 'Air Courier')
        return newType
      } if (type !== 'LCL') { return 'FCL' } return 'LCL'
    },
    getShipmentType (type) {
      if (type === 'AIRCARGO' || type === 'aircargo') {
        const newType = type.replace(type, 'Air Cargo')
        return newType
      } if (type === 'AIRCOURIER' || type === 'aircourier') {
        const newType = type.replace(type, 'Air Courier')
        return newType
      } if (type === 'fcl') {
        return 'FCL'
      } if (type.toUpperCase() === 'BREAKBULK') {
        const newType = type.replace(type, 'Ocean Breakbulk')
        return newType
      } if (type.toUpperCase() === 'AIRBREAKBULK') {
        const newType = type.replace(type, 'Air Breakbulk')
        return newType
      }
      if (type !== 'LCL') { return type } return 'LCL'
    },
    getType (statusShipment) {
      let type = ''
      switch (parseInt(statusShipment, 10)) {
        case 0:
          type = 'Instant Price'
          break
        case 1:
          type = 'RFQ'
          break
        case 2:
          type = 'Contract'
          break
        case 3:
          type = 'Instant Quote'
          break
        default:
          type = ''
      }
      return type
    },
    getDate (date) {
      return moment(date).format('DD MMM YYYY')
    },
    getOptionTp (type) {
      let optionTp = '-'
      switch (type) {
        case 'ptp': optionTp = 'Port to Port'
          break
        case 'dtp': optionTp = 'Door to Port'
          break
        case 'dtd': optionTp = 'Door to Door'
          break
        case 'ptd': optionTp = 'Port to Door'
          break
        default: optionTp = '-'
        /* eslint-disable-next-line */
      }
      /* eslint-disable-next-line */
      return optionTp
      /* eslint-disable-next-line */
    },
    getFilterMonth (date) {
      return moment(date).format('MMMM')
    },
    getFilterYear (date) {
      return moment(date).format('YYYY')
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/manage-shipment/tab_list.js